import { HorizontalView, VerticalView } from 'src/components/FlexViews';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { LeaderBoard } from './components/LeaderBoard';
import { useEffect, useState } from 'react';
import { bonusGameApi } from 'src/api/bonus-game';
import cupImg from 'src/assets/img/bonus-game/cup.webp';
import { TabValue } from './types';
import { TabsSwitcher } from '../../components/Tabs';
import { MobileHeader } from '../../components/Header';
import { PageWrapper } from '../../ui/common';

const HeaderTitle = styled.p`
    text-align: center;
    font-family: Public-Sans, sans-serif;
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
`;

const HeaderWrapper = styled(HorizontalView)`
    ${HeaderTitle} {
        margin: auto;
        position: relative;
        left: -12px;
    }

    margin-bottom: 32px;
`;

const Image = styled.img`
    width: 194px;
    align-self: center;
    z-index: 100;
`;

const Ellipse = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 61px;
    height: 72px;
    background: #f90;
    filter: blur(57.50212860107422px);
`;

const ContentTitle = styled.p`
    font-family: Public-Sans, sans-serif;
    font-size: 18px;
    font-weight: 600;
    line-height: 170%;
    margin-top: 20px;
`;
const ContentDescription = styled.p`
    font-size: 12px;
    font-weight: 500;
    line-height: 170%;
    color: var(--color-neutral-4);
`;
const SeasonDurationWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 22px;
    background: rgba(196, 245, 56, 0.1);
    border-radius: 8px;
    padding: 12px 20px;
    margin: 8px 0 32px;
`;

const SeasonDuration = styled.p`
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    color: #c4f538;
`;

function formatTime(seconds: number) {
  const secondsInMinute = 60;
  const secondsInHour = 3600;
  const secondsInDay = 86400;

  const days = Math.floor(seconds / secondsInDay);
  seconds %= secondsInDay;

  const hours = Math.floor(seconds / secondsInHour);
  seconds %= secondsInHour;

  const minutes = Math.floor(seconds / secondsInMinute);

  return [days, hours, minutes];
}

interface LeaderBoardPageProps {
  isSeasonOver: boolean;
}

export const LeaderBoardPage = ({ isSeasonOver }: LeaderBoardPageProps) => {
  const [leftTime, setLeftTime] = useState([0, 0, 0]);
  const [activeTab, setActiveTab] = useState(TabValue.CurrentSeason);
  const [referrals, setReferrals] = useState(0);

  useEffect(() => {
    (async () => {
      try {
        const promocodeRes = await bonusGameApi.generateInviteCode();
        const promoCodeValue = promocodeRes.result.promoCode;

        const leaderBoardResponse = await bonusGameApi.getLeaderBoard({
          promoCode: promoCodeValue,
        });

        setReferrals(leaderBoardResponse.total);
      } catch (e) {
        console.log('error loading promocode', e);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (isSeasonOver) {
        setLeftTime([0, 0, 0]);
        return;
      }
      const resetDateRes = await bonusGameApi.resetDate();
      const resetDate = Number(resetDateRes.result);
      const interval: any = setInterval(() => {
        const currentTime = Date.now();
        if (currentTime >= resetDate) {
          return clearInterval(interval);
        }

        const formattedTime = formatTime(
          Math.floor((resetDate - currentTime) / 1000),
        );
        setLeftTime(formattedTime);
      }, 1000);
      return () => {
        clearInterval(interval);
      };
    })();
  }, [isSeasonOver]);

  return (
    <PageWrapper>
      <MobileHeader title="Leaderboard"/>
      <div style={{ position: 'relative', alignSelf: 'center' }}>
        <Image src={cupImg}/>
        <Ellipse/>
      </div>
      <VerticalView style={{ alignItems: 'center' }}>
        <ContentTitle>Play daily and win rewards!</ContentTitle>
        <ContentDescription>
          The leaderboard will be reset in:
        </ContentDescription>
        <SeasonDurationWrapper>
          <SeasonDuration>{leftTime[0]} days</SeasonDuration>
          <SeasonDuration>{leftTime[1]} hours</SeasonDuration>
          <SeasonDuration>{leftTime[2]} minutes</SeasonDuration>
        </SeasonDurationWrapper>
        <TabsSwitcher
          tabs={[
            ...Object.values(TabValue)
              .slice(0, -1)
              .map(val => ({ label: val, value: val })),
            {
              label: `${TabValue.Referrals} ${referrals}`,
              value: TabValue.Referrals,
            },
          ]}
          currentTabValue={activeTab}
          onChange={val => setActiveTab(val as TabValue)}
        />
      </VerticalView>
      <LeaderBoard activeTab={activeTab}/>
    </PageWrapper>
  );
};
